"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var zh_cn_1 = require("./locale/zh_cn");
var en_us_1 = require("./locale/en_us");
var ja_1 = require("./locale/ja");
var ko_1 = require("./locale/ko");
exports.translationMap = {
    zh_cn: zh_cn_1.zh_cn,
    zh: zh_cn_1.zh_cn,
    en_us: tslib_1.__assign(tslib_1.__assign({}, zh_cn_1.zh_cn), en_us_1.en_us),
    en: tslib_1.__assign(tslib_1.__assign({}, zh_cn_1.zh_cn), en_us_1.en_us),
    ja: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_cn_1.zh_cn), en_us_1.en_us), ja_1.ja),
    jp: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_cn_1.zh_cn), en_us_1.en_us), ja_1.ja),
    ko: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_cn_1.zh_cn), en_us_1.en_us), ko_1.ko),
};
/* eslint-enable */
//# sourceMappingURL=translationMap.js.map